<template>
    <component :is="sidebarComponent" v-bind="$attrs" @update:expanded="emit('update:expanded', $event)" />
</template>

<script setup>
import PagesSidebar from '@/components/pages/pages/PagesSidebar.vue';
import CorporateSidebar from '@/components/sidebar/CorporateSidebar.vue';
import { resolveClientComponent } from '@/composables/useEdverumClient.js';

defineOptions({
    name: 'DashboardSidebar',
    inheritAttrs: false,
});

const emit = defineEmits(['update:expanded']);

const sidebarComponent = resolveClientComponent({
    stanbridge: PagesSidebar,
    corporate: CorporateSidebar,
});
</script>
